import { appConfig } from '@common/config';
import { Category, type ICategoryProp } from '@components/Category';
import { Checkbox, type ICheckbox } from '@components/Checkbox';
import { type IPriceParams } from '@interface/IItemPrice';
import { useTranslation } from 'react-i18next';
import { FilterWrapTempl } from './FilterWrapTempl';
import { useLocation } from 'react-router-dom';


export const FilterWrapLineageClassic = ({ props }: { props: IPriceParams }) => {
    const { t } = useTranslation();
    const location = useLocation();


    const getSearchType = () => {
        const path = location.pathname;
        const match = path.match(/\/info\/(\w+)/);
        return match ? match[1] : 'item';  // 기본값으로 'item' 반환
    };

    const searchType = getSearchType();

    const classCheckProp: ICheckbox = {
        title: t('common.class'),
        resetObj: { page: '' },
        watch: 'class',
        cls: 'class',
        path: `/${appConfig.service}/v2.0/game/character/class`,
        ga360str: '사전_조건검색_클래스_클릭',
        activeChecked: props.paramClass,
    };

    const categoryProp: ICategoryProp = {
        title: t('common.category'),
        watchD1: 'category1',
        watchD2: 'category2',
        path: `/${appConfig.service}/v2.0/game/item/category`,
        ga360str: '사전_조건검색_카테고리_클릭',
        activeCategory1: props.paramCategory1,
        activeCategory2: props.paramCategory2,
        activeCategory3: null
    };

    const alignmentCheckProp: ICheckbox = {
        title: t('common.alignment'),
        resetObj: { page: '' },
        watch: 'aligns',
        cls: 'aligns',
        path: `/${appConfig.service}/v2.0/game/spell/align`,
        ga360str: '사전_조건검색_등급_클릭',
        activeChecked: props.paramAlignment,
    };

    const spellAttrPropCheckProp: ICheckbox = {
        title: t('common.attr'),
        resetObj: { page: '' },
        watch: 'elementals',
        cls: 'elementals',
        path: `/${appConfig.service}/v2.0/game/spell/elemental`,
        ga360str: '사전_조건검색_등급_클릭',
        activeChecked: props.paramElemental,
    };

    const monsterAttrPropCheckProp: ICheckbox = {
        title: t('common.attr'),
        resetObj: { page: '' },
        watch: 'forms',
        cls: 'forms',
        path: `/${appConfig.service}/v2.0/game/monster/form`,
        ga360str: '사전_조건검색_등급_클릭',
        activeChecked: props.paramForm,
    };

    const monsterCategoryProp: ICategoryProp = {
        title: t('common.category'),
        watchD1: 'region1',
        watchD2: 'region2',
        watchD3: 'region3',
        path: `/${appConfig.service}/v2.0/game/monster/region`,
        ga360str: '사전_조건검색_카테고리_클릭',
        activeCategory1: props.paramRegion1,
        activeCategory2: props.paramRegion2,
        activeCategory3: props.paramRegion3,
    };

    return (
        <FilterWrapTempl refreshObj={refObj}>
            {searchType === 'item' && (
                <>
                    <Checkbox props={classCheckProp} />
                    <Category props={categoryProp} />
                </>
            )}

            {/* spell인 경우 */}
            {searchType === 'spell' && (
                <>
                    <Checkbox props={classCheckProp} />
                    <Checkbox props={alignmentCheckProp} />
                    <Checkbox props={spellAttrPropCheckProp} />
                </>
            )}

            {/* monster인 경우 */}
            {searchType === 'monster' && (
                <>
                    <Checkbox props={monsterAttrPropCheckProp} />
                    <Category props={monsterCategoryProp} />
                </>
            )}

        </FilterWrapTempl>
    );
};

const refObj = {
    class: '',
    grade: '',
    category1: '',
    category2: '',
    page: '',
    aligns: '',
    elementals: '',
    forms: '',
    region1: '',
    region2: '',
    region3: '',
};
